















import { Vue, Component } from 'vue-property-decorator';
import {
  SortingOption,
  SearchFilters,
  SearchResultProcess,
  SortingOptionParams
} from '@/store/modules/searchInterfaces';
import SelectionField from '../common/inputs/SelectionField.vue';
import { State, Action } from 'vuex-class';
import { isEqual } from 'lodash';
import excelBtn from '@/components/search/ExcelBtn.vue';
import { SearchModule } from '@/store/modules/search';

interface DropdownSortingOption {
  text: string;
  ascLabel?: string;
  descLabel?: string;
  value: SortingOption;
}

@Component({
  components: {
    SelectionField,
    excelBtn
  }
})
export default class SearchSortingDropdown extends Vue {
  ascLabel = '（低い順）';
  descLabel = '（高い順）';

  keys: Array<{ property: keyof SortingOptionParams; text: string; ascLabel?: string; descLabel?: string }> = [
    { property: 'created', text: '新しい順' },
    { property: 'title', text: 'プロセス', ascLabel: '（A→Z）', descLabel: '（Z→A）' }
  ];

  options: DropdownSortingOption[] = this.keys.reduce(
    (options: DropdownSortingOption[], { property, text, ascLabel, descLabel }) => {
      return ascLabel && descLabel
        ? [
            ...options,
            { text: `${text}${ascLabel}`, value: { property, descending: false } },
            { text: `${text}${descLabel}`, value: { property, descending: true } }
          ]
        : [...options, { text: `${text}`, value: { property, descending: true } }];
    },
    []
  );

  updateFilters(filters: SearchFilters) {
    return SearchModule.updateFilters({
      ...filters
    });
  }

  get formattedOption(): DropdownSortingOption {
    return (
      this.options.find(({ value: { property } }) => property === SearchModule.filters.sorting.property) || {
        text: `不明な並べ替え条件：${SearchModule.filters.sorting.property}`,
        value: SearchModule.filters.sorting
      }
    );
  }
}
